angular.module('octopusApp.environments')
    .controller('MachineLayoutController', function MachineLayoutController($scope, machineState) {
        var self = $scope;
        self.machine = null;
        self.machineId = machineState.machineId;
        self.isLoading = machineState.isLoading;
        self.isSaving = machineState.isSaving;
        $scope.$watch(function () {
            return machineState.machine;
        }, function (machine) {
            self.machine = machine;
        });
    }).provider('machineState', function machineState() {
        this.$get = function ($stateParams, $timeout, busy, octopusRepository) {
            var state = {
                isLoading: busy.create(),
                isSaving: busy.create(),
                machineId: $stateParams.machineId,
                machineAsync: null,
                machine: null
            };

            function load() {
                state.machineAsync = octopusRepository.Machines.get(state.machineId);
                state.isLoading.promise(state.machineAsync.then(function (machine) {
                    state.machine = machine;
                }));
                return state.machineAsync;
            }

            state.load = load;

            $timeout(function() {
                if (!state.machineAsync) {
                    console.warn("Machine State was not populated by content controller.");
                    load();
                }
            }, 5000);

            return state;
        };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/controllers/machine_layout_controller.js
// module id = 420
// module chunks = 1